/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import {
  BuilderFormSchemaFactory,
  BuilderUserContext, FormRootSchema, FormStateSchema,
  TaxRate,
  whenAuOrNzRegion,
  whenCreateOrEditMode,
} from '@gh/builder-shared';
import { BuilderPermission, SystemVarsLedgerDto } from '@gh/builder-shared-data';
import { DateTimeTypes, FormState, NumberTypes } from '@gh/common-shared';
import { FormMode, getControlValue, markControlAsDirty, setControlValue } from '@gh/core-ui';

@Injectable()
export class SystemVarsLedgerTabFormState extends FormState<SystemVarsLedgerDto> {
  constructor(
    private userContext: BuilderUserContext,
    schemaFactory: BuilderFormSchemaFactory,
  ) {
    super(schemaFactory);
  }

  get gstForIncome(): Maybe<TaxRate> {
    return getControlValue(this.group, 'gstForIncome');
  }

  gstAppliesChange(): void {
    const gstApplies = this.get('gstApplies');
    const gstPct = this.get('gstPct');

    gstPct.updateSchema({
      required: gstApplies.value,
    });
  }

  setGstForIncome(taxRate: TaxRate): void {
    setControlValue(this.group, 'gstForIncome', taxRate);
    markControlAsDirty(this.group, 'gstForIncome');
  }

  protected buildSchema(model: SystemVarsLedgerDto, { root }: FormStateSchema): FormRootSchema {
    const mode = this.userContext.hasPermission(BuilderPermission.Setup.SystemVariables.Ledger.EDIT)
      ? FormMode.EditMode
      : FormMode.ViewMode;

    return root({
      enabled: whenCreateOrEditMode(),
      mode,
      optimisticLock: true,
      children: {
        gstApplies: { visible: whenAuOrNzRegion() },
        gstPct: { visible: whenAuOrNzRegion(), required: model.gstApplies, type: NumberTypes.Percents_2 },
        currentFinYear: { enabled: false },
        lastMonthFinYear: { enabled: false },
        conversionDate: { type: DateTimeTypes.ShortDate, enabled: false },
        gstForIncome: { visible: whenAuOrNzRegion(), enabled: false },
      },
    });
  }
}
